// Uses the platform's existing CKEditor 5 classic build (already a dependency, see
// components/Forms/CkEditor/CkEditor.js for the original usage) as-is.
//
// NOTE: We previously tried extending ClassicEditor.builtinPlugins at runtime with
// separate @ckeditor/ckeditor5-font and @ckeditor/ckeditor5-alignment packages to add
// Font Color / Alignment toolbar buttons. That crashed the entire app on every page
// load with CKEditorError: ckeditor-duplicated-modules — ckeditor5-build-classic ships
// its own pre-webpacked copy of ckeditor5-core/engine, and importing the raw plugin
// source packages pulls in a second, separately-bundled copy of the same engine
// classes, which CKEditor's own duplicate-module guard rejects at import time. Since
// this app has no route-based code splitting, that throw took down every route, not
// just the email template page. Reverted to the stock classic build's built-in
// plugins only (Bold/Italic/Underline/Headings/Link/Image/Lists/Table/Blockquote).
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

export const EMAIL_EDITOR_TOOLBAR = [
    'heading', '|',
    'bold', 'italic', 'underline', '|',
    'link', 'bulletedList', 'numberedList', 'outdent', 'indent', '|',
    'uploadImage', 'insertTable', 'blockQuote', '|',
    'undo', 'redo',
];

export default ClassicEditor;
